import React, { useContext } from 'react'

import { ErrorContext } from '../contexts/errorContext'
import AlertFactory from '../components/alerts/AlertFactory'
import alertList from '../constants/alertList'
import '../styles/userAlert.scss'

export default function UserAlert(props) {
    const errorContext = useContext(ErrorContext)

    if (
        errorContext.currentErrorMessage !== null &&
        errorContext.currentErrorMessage !== undefined &&
        alertList[errorContext.currentErrorMessage.errorKey]
    ) {
        return (
            <AlertFactory
                closeCurrentErrorMessage={errorContext.closeCurrentErrorMessage}
                {...errorContext.currentErrorMessage}
            />
        )
    }
    return ''
}
